/* eslint-disable import/no-anonymous-default-export */
import { combineReducers } from 'redux';
import { routerReducer as router } from 'react-router-redux';

import cars from './cars';
import options from './options';
import error from './error';

// This is needed for the builder to pick up all of the reducers
export const ALL_REDUCERS = {
  cars,
  options,
  router,
  error,
};

const rootReducer = combineReducers(ALL_REDUCERS);

export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js